import { CSRF_TOKEN_NAME } from '@/constants'
import { client } from './client'
import { getCsrf, getCookie } from './authentication'
import { CustomError } from '../CustomError'

export const createDocumentPageAssemblyGroupIDs = async (
  documentPageId: string,
  assemblyGroupIds: string[],
) => {
  await getCsrf()
  const resp = await client.POST(
    '/api/v1/projects/{document_page_id}/document_page_assembly_group_ids/bulk',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_page_id: documentPageId,
        },
      },
      body: {
        assembly_group_ids: assemblyGroupIds,
      },
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to bulk create document page assembly group id'
    throw new CustomError(resp, message)
  }

  return resp.data
}

export const deleteDocumentPageAssemblyGroupID = async (
  documentPageAssemblyReferenceId: number,
) => {
  await getCsrf()
  const resp = await client.DELETE(
    '/api/v1/projects/document_page_assembly_group_ids/{document_page_assembly_group_id_id}',
    {
      headers: {
        'X-CSRFToken': getCookie(CSRF_TOKEN_NAME),
      },
      params: {
        path: {
          document_page_assembly_group_id_id: String(
            documentPageAssemblyReferenceId,
          ),
        },
      },
      parseAs: 'text',
    },
  )

  if (resp.error || !resp.response.ok) {
    const message = 'Failed to delete document page assembly group id'
    throw new CustomError(resp, message)
  }

  return true
}
